module.exports = __webpack_public_path__ + "static/media/blue-white-measure-tape-long-horizontal.70492dfb.png";